import { ILatestPayRatesReportQuery } from 'modules/settings/submodules/clients/reports/store/models';
import { createRequestActions, RequestType } from 'store/utils';

export const getLatestSubassignmentsPayRatesReport = createRequestActions<ILatestPayRatesReportQuery, void>(
    RequestType.Get,
    'LATEST_SUBASSIGNMENT_PAY_RATES',
    'reports',
);
